/**
 * Created by sunke on 2018/4/25.
 * Modify by handd on 2018/5/3.
 */
import axios from "axios";

// const
const REDIRECT_TO_EQUIPMENT_CONFIG_PAGE = "equipmentConfig/REDIRECT_TO_EQUIPMENT_CONFIG_PAGE";
const EQUIPMENT_CONFIG_INITIAL_DATA = "equipmentConfig/EQUIPMENT_CONFIG_INITIAL_DATA";
const EQUIPMENT_CONFIG_NEW_DATA = "equipmentConfig/EQUIPMENT_CONFIG_NEW_DATA";
const EQUIPMENT_CONFIG_UPDATE_DATA = "equipmentConfig/EQUIPMENT_CONFIG_UPDATE_DATA";
const EQUIPMENT_CONFIG_STORE_COMPRESS_METHODS = "equipmentConfig/EQUIPMENT_CONFIG_STORE_COMPRESS_METHODS";
const EQUIPMENT_CONFIG_STORE_TRANSFER_PROTOCOLS = "equipmentConfig/EQUIPMENT_CONFIG_STORE_TRANSFER_PROTOCOLS";
const EQUIPMENT_CONFIG_STORE_COLLECT_NODE_TREE = "equipmentConfig/EQUIPMENT_CONFIG_STORE_COLLECT_NODE_TREE";
const EQUIPMENT_CONFIG_TOGGLE_MODAL = "equipmentConfig/EQUIPMENT_CONFIG_TOGGLE_MODAL";
const EQUIPMENT_CONFIG_TOGGLE_LOADING = "equipmentConfig/EQUIPMENT_CONFIG_TOGGLE_LOADING";
const EQUIPMENT_CONFIG_TOGGLE_SELECT = "equipmentConfig/EQUIPMENT_CONFIG_TOGGLE_SELECT";

// modal const
export const EQUIPMENT_CONFIG_MODAL_SUCCESS_TITLE = "scenes_Equipment_EquipmentManagement_EquipmentConfig_modal_success_title";
export const EQUIPMENT_CONFIG_MODAL_FAIL_TITLE = "scenes_Equipment_EquipmentManagement_EquipmentConfig_modal_fail_title";
export const EQUIPMENT_CONFIG_MODAL_SUBMIT_SUCCESS_CONTENT = "scenes_Equipment_EquipmentManagement_EquipmentConfig_modal_submitSuccess_content";
export const EQUIPMENT_CONFIG_MODAL_SUBMIT_FAIL_CONTENT = "scenes_Equipment_EquipmentManagement_EquipmentConfig_modal_submitFail_content";
export const EQUIPMENT_CONFIG_MODAL_OK_LABEL = "scenes_Equipment_EquipmentManagement_EquipmentConfig_modal_OK_label";
export const EQUIPMENT_CONFIG_MODAL_CANCEL_LABEL = "scenes_Equipment_EquipmentManagement_EquipmentConfig_modal_cancel_label";
export const EQUIPMENT_CONFIG_MODAL_YES_LABEL = "scenes_Equipment_EquipmentManagement_EquipmentConfig_modal_yes_label";
export const EQUIPMENT_CONFIG_MODAL_NO_LABEL = "scenes_Equipment_EquipmentManagement_EquipmentConfig_modal_no_label";


// reducer
export const equipmentConfig = (state = {
  loading: false,

  modalVisible: false,
  modalTitle: "",
  modalContent: "",
  modalOk: "",
  modalCancel: "",
  onOk: null,
  onCancel: null,

  tabKey: "tab_1",
  selectedRowKeys: [],
  checkedKeys: [],

  id: "",
  equipmentId: "",
  transferProtocol: "",
  transferProtocols: [],
  compressMethod: "",
  compressMethods: [],
  dataTransferUrl: "",
  fileTransferUrl: "",
  period: "",
  buffer: "",
  collectNodeTree: [],
  collectNodeConfigs: [],


}, action) => {
  switch (action.type) {

    case EQUIPMENT_CONFIG_UPDATE_DATA:
      return {
        ...state,
        [action.data.name]: action.data.value
      };
    case EQUIPMENT_CONFIG_INITIAL_DATA:
      return {
        ...state,
        modalVisible: false,
        tabKey: "tab_1",
        equipmentId: action.data.equipmentId,
        id: action.data.id,
        transferProtocol: action.data.transferProtocol.code,
        dataTransferUrl: action.data.dataTransferUrl,
        fileTransferUrl: action.data.fileTransferUrl,
        compressMethod: action.data.compressMethod.code,
        period: action.data.period,
        buffer: action.data.buffer,
        collectNodeConfigs: action.data.collectNodeConfigs,
      };
    case EQUIPMENT_CONFIG_NEW_DATA:
      return {
        ...state,
        modalVisible: false,
        tabKey: "tab_1",
        equipmentId: action.data,
        id: "",
        transferProtocol: "",
        dataTransferUrl: "",
        fileTransferUrl: "",
        compressMethod: "",
        period: "",
        buffer: "",
        collectNodeConfigs: [],
      };
    case EQUIPMENT_CONFIG_TOGGLE_MODAL:
      return {
        ...state,
        modalVisible: action.data.modalVisible,
        modalTitle: action.data.modalTitle,
        modalContent: action.data.modalContent,
        modalOk: action.data.modalOk,
        modalCancel: action.data.modalCancel,
        onOk: action.data.onOk,
        onCancel: action.data.onCancel
      };
    case EQUIPMENT_CONFIG_STORE_COMPRESS_METHODS:
      return {
        ...state,
        compressMethods: action.data
      };
    case EQUIPMENT_CONFIG_STORE_TRANSFER_PROTOCOLS:
      return {
        ...state,
        transferProtocols: action.data
      };
    case EQUIPMENT_CONFIG_STORE_COLLECT_NODE_TREE:
      return {
        ...state,
        collectNodeTree: action.data
      };
    case EQUIPMENT_CONFIG_TOGGLE_LOADING:
      return {
        ...state,
        loading: action.data
      };
    default:
      return state
  }
};

/**
 * update data based on user input
 */
export const updateEquipmentConfigData = (data) => {
  return {
    type: EQUIPMENT_CONFIG_UPDATE_DATA,
    data: data
  }
};

/**
 * check and init equipment config
 */
export const initEquipmentConfig = (data) => (dispatch) => {
  let equipmentId = data.equipmentId;
  if (equipmentId !== null && equipmentId !== undefined && equipmentId !== "") {
    dispatch(toggleLoading(true));
    axios.get(`/api-equipment/getEquipmentConfigByEquipmentId/${equipmentId}`, {contentType: "application/json"}).then(
      response => {
        dispatch(toggleLoading(false));
        if (response.data) {
          response.data.equipmentId = data.equipmentId;
          dispatch(storeEquipmentConfig(response.data));
        } else {
          dispatch(storeNewEquipmentConfig(data.equipmentId));
        }
      }
    );
    axios.get(`/api-equipment/getCollectNodeTreeByEquipmentId/${equipmentId}`, {contentType: "application/json"}).then(
      response => {
        dispatch(toggleLoading(false));
        if (response.data) {
          dispatch(storeCollectNodeTree(response.data));
        } else {
          dispatch(storeCollectNodeTree([]));
        }
      }
    ).catch(
      err => {
        //设备网关服务无法接通，导致数采服务抛出异常
        dispatch(toggleLoading(false));
        console.error("fail to get node tree:", err);
      }
    );
  } else {
    dispatch(toggleLoading(false));
    this.props.history.push("/exception/415");
  }
};

/**
 * store init equipment config
 */
export const storeEquipmentConfig = (equipmentConfig) => {
  return {
    type: EQUIPMENT_CONFIG_INITIAL_DATA,
    data: equipmentConfig
  }
};

/**
 * store new equipment config
 */
export const storeNewEquipmentConfig = (equipmentId) => {
  return {
    type: EQUIPMENT_CONFIG_NEW_DATA,
    data: equipmentId
  }
};

/**
 * store collect Node Tree
 */
export const storeCollectNodeTree = (collectNodeTree) => {
  return {
    type: EQUIPMENT_CONFIG_STORE_COLLECT_NODE_TREE,
    data: collectNodeTree
  }
};

/**
 * get all transfer protocols
 */
export const getTransferProtocols = () => (dispatch) => {
  dispatch(toggleLoading(true));
  axios.get("/api-equipment/getTransferProtocols", {contentType: "application/json"}).then(
    response => {
      if (response.data) {
        dispatch(storeTransferProtocols(response.data));
        dispatch(toggleLoading(false));
      }
    }
  );
};

/**
 * store all transfer protocols
 */
export const storeTransferProtocols = (transferProtocols) => {
  return {
    type: EQUIPMENT_CONFIG_STORE_TRANSFER_PROTOCOLS,
    data: transferProtocols
  }
};

/**
 * get all compress methods
 */
export const getCompressMethods = () => (dispatch) => {
  dispatch(toggleLoading(true));
  axios.get("/api-equipment/getCompressMethods", {contentType: "application/json"}).then(
    response => {
      if (response.data) {
        dispatch(storeCompressMethods(response.data));
        dispatch(toggleLoading(false));
      }
    }
  );
};

/**
 * store all compress methods
 */
export const storeCompressMethods = (compressMethods) => {
  return {
    type: EQUIPMENT_CONFIG_STORE_COMPRESS_METHODS,
    data: compressMethods
  }
};

/**
 * toggle modal
 */
export const toggleModal = (show) => {
  return {
    type: EQUIPMENT_CONFIG_TOGGLE_MODAL,
    data: show
  }
};

/**
 * toggle loading
 */
export const toggleLoading = (show) => {
  return {
    type: EQUIPMENT_CONFIG_TOGGLE_LOADING,
    data: show
  }
};
